module.exports = __webpack_public_path__ + "img/a01-1.7716b638.jpg";